import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=88c6970c&scoped=true&"
import script from "./Report.vue?vue&type=script&lang=js&"
export * from "./Report.vue?vue&type=script&lang=js&"
import style0 from "./Report.vue?vue&type=style&index=0&id=88c6970c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c6970c",
  null
  
)

export default component.exports